import { API } from "../client-api/schema";
import { defineEndpoint } from "./endpoint";
import { queryFor } from "./query";

export const tenantsEndpoint = defineEndpoint({
  resource: "me/tenants",
  path: API.me.tenants.Path,
  responseSchema: API.me.tenants.Response,
});

export const tenantsQuery = queryFor(tenantsEndpoint);

export const identityEndpoint = defineEndpoint({
  resource: "me/identity",
  path: API.me.identity.Path,
  responseSchema: API.me.identity.Response,
});

export const identityQuery = queryFor(identityEndpoint);
